import React from 'react'
import { Form, Input, Icon, Label } from 'semantic-ui-react'
import MaskedInput from 'react-text-mask'

const PhoneInput = ({ error, onChange, action }) => {
  return (
    <Form.Field error={!!error}>
      <label htmlFor="phone">Phone Number</label>
      <Input type="text" iconPosition="left" className={action ? 'action' : ''}>
        <Icon name="mobile alternate" />
        <MaskedInput
          mask={[
            '(',
            /[1-9]/,
            /\d/,
            /\d/,
            ')',
            ' ',
            /\d/,
            /\d/,
            /\d/,
            '-',
            /\d/,
            /\d/,
            /\d/,
            /\d/,
          ]}
          id="phone"
          placeholder="(555) 555 5555"
          onChange={onChange}
        />
        {action}
      </Input>
      {error && <Label prompt pointing="above" content={error} />}
    </Form.Field>
  )
}

export default PhoneInput
